<template>
  <div class="icon-title-wrap">
    <div class="icon">
      <img :src="img" />
    </div>
    <div class="content">
      <div class="label" @click="show(describe)">
        {{ label }}
        <i class="el-icon-search" style="color: green"></i>
      </div>
      <el-tag @click="show(remark)" effect="dark" type="success">{{
        result
      }}</el-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: "xiao",
    },
    label: {
      default: "焦虑情绪评估",
    },
    result: {
      default: "未体现",
    },
    describe: {
      default: "描述",
    },
    remark: {
      default: "备注",
    },
  },
  computed: {
    img() {
      return require("@/assets/" + this.type + ".png");
    },
  },
  methods: {
    show(text) {
      this.$alert(text, "提示");
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-title-wrap {
  display: flex;
  align-items: flex-start;
  margin: 15px 15px 15px 5px;
  .icon {
    background-color: #fff;
    img {
      width: 55px;
      height: 55px;
    }
  }
  .content {
    font-size: 14px;
    color: #333;
    margin-left: 15px;
    .label {
      margin-bottom: 5px;
    }
  }
}
</style>